
export default function YouTube() {
  const channels = [
    {
      id: 1,
      title: '不動産Gメン滝島',
      description: '光文堂インターナショナル様所有の物件を当社がリフォームしています。私達を選んで頂きありがとうございます。',
      videoId: 'Fzo3O0WZb68',
      thumbnail: 'https://static.readdy.ai/image/4f63d300aa74833e61c135d0fc4d72e6/ec786e0f1b134f419754ad4f7eab973e.png',
      url: 'https://youtu.be/Fzo3O0WZb68?si=idGIYLqUOtoKYr5t'
    },
    {
      id: 2,
      title: 'YouTubeチャンネル',
      description: '空き家/廃墟専門YouTube番組「珍物件・地雷物件潜入チャンネル」',
      videoId: 'i6q0ppNMKwc',
      thumbnail: 'https://static.readdy.ai/image/4f63d300aa74833e61c135d0fc4d72e6/75f8e50f56dbbf479d215753832152c6.jpeg',
      url: 'https://www.youtube.com/@地上げ屋-x8u'
    },
    {
      id: 3,
      title: '譲渡型賃貸住宅マリアージュ賃貸',
      description: '「誰でも家を買える社会を実現する」住宅ローン不要でお家が譲渡される新しい住宅購入の仕組み',
      videoId: 'frvu4jtCZPY',
      url: 'https://youtu.be/frvu4jtCZPY?si=N76WCfrjGHHm6auL'
    }
  ];

  return (
    <section id="youtube" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-lg sm:text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4 whitespace-nowrap">人気YouTubeチャンネル出演中</h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto">
            不動産・建築に関する有益な情報をお届けしています
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:gap-8">
          {channels.map((channel) => (
            <div
              key={channel.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 flex flex-col lg:flex-row"
            >
              <div className="relative w-full lg:w-[560px] flex-shrink-0">
                <div className="relative w-full aspect-video">
                  {channel.thumbnail ? (
                    <a 
                      href={channel.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block w-full h-full group cursor-pointer"
                    >
                      <img
                        src={channel.thumbnail}
                        alt={channel.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="w-14 h-14 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center">
                          <i className="ri-play-fill text-white text-2xl md:text-3xl"></i>
                        </div>
                      </div>
                    </a>
                  ) : (
                    <iframe
                      className="absolute inset-0 w-full h-full"
                      src={`https://www.youtube.com/embed/${channel.videoId}?autoplay=0&mute=0&controls=1&loop=0`}
                      title={channel.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-6 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2 md:mb-3">
                  <div className="w-7 h-7 md:w-8 md:h-8 bg-red-600 rounded-full flex items-center justify-center">
                    <i className="ri-youtube-fill text-white text-base md:text-lg"></i>
                  </div>
                  <h3 className="text-base md:text-xl font-bold text-gray-900">{channel.title}</h3>
                </div>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-3 md:mb-4">{channel.description}</p>
                <a 
                  href={channel.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap inline-flex items-center gap-2 text-red-600 hover:text-red-700 font-semibold cursor-pointer transition-colors text-sm md:text-base"
                >
                  <span>チャンネルを見る</span>
                  <i className="ri-external-link-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
